import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { CatalogoItemApi } from '../models/api/auth-api';
import { ResponseApi } from '../models/response-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class CatalogoService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/catalogo/';

    listTiposProducto(): Observable<CatalogoItemApi[]> {
        return this.http.get<ResponseApi<CatalogoItemApi[]>>(this.url + 'list-tipos-producto').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    listTiposMetodoPago(): Observable<CatalogoItemApi[]> {
        return this.http.get<ResponseApi<CatalogoItemApi[]>>(this.url + 'list-tipos-metodo-pago').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    listEstadosPedido(): Observable<CatalogoItemApi[]> {
        return this.http.get<ResponseApi<CatalogoItemApi[]>>(this.url + 'list-estados-pedido').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }
}
